import { takeEvery, fork } from 'redux-saga/effects';
import * as types from '../constants/ActionTypes';
import {
  currencyMapping,
  convertErrorsFromDjango,
} from './users/usersConstants';
import {
  updateProfile,
  changeLanguage,
  fetchDefaultCountry,
  requestUser,
  unhijack,
  handleLogout,
  saveLoginProvider,
  uploadAvatar,
  handleAuth,
} from './users/usersAuthSaga';
import {
  selectSubcategory,
  deleteSubcategory,
  selectLanguage,
  deleteSelectedLanguage,
  sendUserInfo,
  receiveUserInfo,
  signup,
  requestCategories,
  redirectAuthors,
} from './users/usersOnboardingSaga';
import { addRequisites, updateRequisites } from './users/usersRequisitesSaga';

export {
  currencyMapping,
  convertErrorsFromDjango,
  updateProfile,
  changeLanguage,
  fetchDefaultCountry,
  requestUser,
  unhijack,
  handleLogout,
  saveLoginProvider,
  uploadAvatar,
  handleAuth,
  selectSubcategory,
  deleteSubcategory,
  selectLanguage,
  deleteSelectedLanguage,
  sendUserInfo,
  receiveUserInfo,
  signup,
  requestCategories,
  redirectAuthors,
  addRequisites,
  updateRequisites,
};

export default function* watchUsers() {
  yield fork(() => takeEvery(types.USER_UPDATE, updateProfile));
  yield takeEvery(types.FETCH_DEFAULT_COUNTRY, fetchDefaultCountry);
  yield takeEvery(types.CHANGE_LANGUAGE, changeLanguage);
  yield takeEvery(types.REQUEST_USER, requestUser);
  yield takeEvery(types.RECEIVE_USER, handleAuth);
  yield takeEvery(types.RECEIVE_USER, redirectAuthors);
  yield takeEvery(types.UPLOAD_AVATAR, uploadAvatar);
  yield takeEvery(types.LOGOUT, handleLogout);
  yield takeEvery(types.SIGNUP, signup);
  yield takeEvery(
    [types.RECEIVE_USER_INFO, types.CHANGE_LANGUAGE_SUCCESS],
    receiveUserInfo
  );
  yield takeEvery(types.SEND_USER_INFO, sendUserInfo);
  yield takeEvery(types.REQUEST_CATEGORIES, requestCategories);
  yield takeEvery(types.SELECT_SUBCATEGORY, selectSubcategory);
  yield takeEvery(types.DELETE_SELECTED_SUBCATEGORY, deleteSubcategory);
  yield takeEvery(types.SELECT_LANGUAGE, selectLanguage);
  yield takeEvery(types.DELETE_SELECTED_LANGUAGE, deleteSelectedLanguage);
  yield takeEvery(types.USER_CLICK_LOGIN, saveLoginProvider);
  yield takeEvery(types.UNHIJACK, unhijack);
  yield takeEvery(types.ADD_REQUISITES, addRequisites);
  yield takeEvery(types.UPDATE_REQUISITES, updateRequisites);
}
